import { useEffect, useState } from "react";
import { useLazyQuery, useQuery } from "@apollo/client/react";
import moment from "moment";
import { usePersistFilters } from "../../../hooks/usePersistFilters";
import { GET_TIPO_PROFESIONALES } from "../../../data/graphQL/queries/AdminRoles/getTipoProfesionales";
import { GET_DELEGACIONES_BY_USUARIO } from "../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario";
import { adaptDelegacionArray } from "../../../adapters/delegacionAdapter";

const idUsuarioLoggeado = sessionStorage.getItem("idUsuario");

export const useGetFilters = (setIsRefetchRequired) => {
    const [delegaciones, setDelegaciones] = useState([]);
    const [tiposProfesional, setTiposProfesional] = useState([]);

    const { filters, handleChangeFilters: persistHandleChange } = usePersistFilters(
        {
            mes: moment().month() + 1,
            anio: moment().year(),
            idTipoProfesional: null,
            idDelegacion: null,
        },
        "rvMailFilters"
    );

    const handleChangeFilters = (name, value) => {
        setIsRefetchRequired(true);
        persistHandleChange(name, value);
    };

    // ── Tipos de Profesional ──────────────────────────────────────────────────

    const { data: tipoProfesionalData } = useQuery(GET_TIPO_PROFESIONALES);

    useEffect(() => {
        if (!tipoProfesionalData) return;
        const opciones = tipoProfesionalData?.tipoProfesionales?.valorEsperado ?? [];
        setTiposProfesional(
            opciones?.map((x) => ({ id: x.idTipoProfesional, displayName: x.descripcion }))
        );
    }, [tipoProfesionalData]);

    // ── Delegaciones ──────────────────────────────────────────────────────────

    const [getDelegaciones, { data: dataDelegaciones }] = useLazyQuery(
        GET_DELEGACIONES_BY_USUARIO,
        { fetchPolicy: "no-cache" }
    );

    useEffect(() => {
        const idUsuario = JSON.parse(idUsuarioLoggeado);
        getDelegaciones({ variables: { idUsuario } });
    }, [getDelegaciones]);

    useEffect(() => {
        if (!dataDelegaciones) return;
        const adaptadas = adaptDelegacionArray(dataDelegaciones)?.filter((x) => x.id !== null) ?? [];
        setDelegaciones(adaptadas);
    }, [dataDelegaciones]);

    return {
        filters,
        handleChangeFilters,
        delegaciones,
        tiposProfesional,
    };
};
